var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-item-result" }, [
    _c(
      "a",
      {
        staticClass: "search-item-result__link",
        attrs: { href: _vm.item.link },
      },
      [
        _c(
          "div",
          { staticClass: "search-item-result__img-wrapper" },
          [
            _c("v-picture", {
              staticClass: "search-item-result__img",
              attrs: { image: _vm.item.picture },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "search-item-result__text-content" }, [
          _c("p", { staticClass: "search-item-result__name" }, [
            _vm._v(_vm._s(_vm.item.name)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "search-item-result__price" }, [
            _vm._v(_vm._s(_vm.formattedPrice) + " ₽"),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }